import React from 'react';
import { nl2br } from '@/shared/nl2br';

const Top = ({ main_concept, concept_text, main_concept_image }) => {
    return (
        <div className="concept-intro background-color--contents_bg ">
            <div className="concept-intro__contents text--center">
                <div className="section-heading">
                    <h1 className="section-heading__title color--accent font-family--large">MESSAGE</h1>
                    <p className="section-heading__sub font-family--middle">想い・メッセージ</p>
                </div>
                <img className="concept-intro__img" src={main_concept_image} width="600" height="450" alt={main_concept} />
                <h2 className="concept-intro__title color--accent font-family--middle">{nl2br(main_concept)}</h2>
                <p className="text__body color--text">{nl2br(concept_text)}</p>
            </div>
        </div>
    );
}

export default Top;
